import { Button } from "@fanduel/formation-react-components";
import { PropsWithChildren } from "react";
import styles from "./toggleSwitch.module.scss";

export const ToggleSwitch = ({ children }: PropsWithChildren) => {
  return <div className={styles.outline}>{children}</div>;
};

interface ToggleButtonProps {
  label: string;
  isActive: boolean;
  onClick: (event: React.MouseEvent) => void;
}

export const ToggleButton = (props: ToggleButtonProps) => {
  const { label, isActive, onClick } = props;
  return (
    <Button
      label={label}
      size="small"
      variant={isActive ? "secondary" : "link"}
      onClick={onClick}
    />
  );
};
